import { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';
import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';

type CheckboxInputProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = {
  form: UseFormReturn<TFieldValues>;
  name: TName;
  label: string;
} & Omit<CheckboxProps, 'name' | 'checked' | 'onChange' | 'value'>;

export function CheckboxInput<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({ form, name, label, ...rest }: CheckboxInputProps<TFieldValues, TName>) {
  return (
    <FormControlLabel
      control={<Checkbox {...form.register(name)} {...rest} />}
      label={label}
    />
  );
}
